import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.timers";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:

 Perform a location-based navigation.
*/
import assignLocation from '../support/assign-location';
import { getStore } from '../../store/store';
import { workingStart, workingEnd, hideSpinner } from 'wfui-digital-core/es/actions';
import { showStopMessage } from '../../store/stop-message/actions';
import { showConfirmation } from '../../store/navigation/actions';
import globals from '../../globals/globals';
import testNetwork from '../support/test-network';
import getString from '../../strings/get-string';
import logger from '../../logger/logger';
var defaultOptions = {
  testNetwork: true,
  showSpinner: true
};
var navigationType = 'Location navigation'; // Start the location navigation process. Show the working overlay if we're
// going to test the network. Showing the spinner on the overlay is optional
// Returns the settings

var _start = function _start(navigation) {
  var settings = Object.assign({}, defaultOptions, navigation);
  logger.debug("".concat(navigationType, ": Starting"));
  return Promise.resolve(settings);
}; // Test the network if the options indicate. Returns a promise that resolves
// if the network test passes, and that rejects if otherwise


var _testNetwork = function _testNetwork(navigation) {
  var navigationItem = navigation.navigationItem;

  if (navigation.testNetwork && !navigation.navigationItem.initiatedFromSAML) {
    logger.debug("".concat(navigationType, ": Testing network"));

    if (!navigationItem.initiatedFromSAML) {
      getStore().dispatch(workingStart({
        showSpinner: navigation.showSpinner
      }));
    }

    return new Promise(function (resolve, reject) {
      testNetwork().then(function () {
        return resolve(navigation);
      }, function () {
        reject(Object.assign(navigation, {
          failureReason: 'Network test failed'
        }));
      });
    });
  } else {
    return Promise.resolve(navigation);
  }
};

var _confirmExternalNavigation = function _confirmExternalNavigation(navigation) {
  var navigationItem = navigation.navigationItem;
  navigation.confirmationDeclined = false;
  return new Promise(function (resolve, reject) {
    if (navigationItem.externalNavigation && !navigationItem.initiatedFromSAML) {
      new Promise(function (confirmResolve, confirmReject) {
        getStore().dispatch(showConfirmation({
          confirmationType: 'external',
          confirmResolve: confirmResolve,
          confirmReject: confirmReject
        }));
      }).then(function () {
        return resolve(navigation);
      }, function () {
        navigation.confirmationDeclined = true;
        reject(navigation);
      });
    } else {
      resolve(navigation);
    }
  });
}; // If the network test passed (or was not required), set the location
// using the url property


var _doNavigation = function _doNavigation(navigation) {
  logger.debug("".concat(navigationType, ": Assigning location: ").concat(navigation.navigationItem.url));
  var navigationItem = navigation.navigationItem;
  assignLocation(navigationItem.url);
  return Promise.resolve(navigation);
}; // Log the result and hide the working overlay if the network was tested


var _cleanup = function _cleanup(navigation) {
  var navigationItem = navigation.navigationItem;
  logger.debug("".concat(navigationType, ": Cleanup"));

  if (globals().nativeWrapped && !navigationItem.initiatedFromSAML) {
    getStore().dispatch(hideSpinner());
    setTimeout(function () {
      return getStore().dispatch(workingEnd());
    }, 2000);
  }

  return Promise.resolve(navigation);
};

export default (function (navigation) {
  return new Promise(function (resolve, reject) {
    return _start(navigation).then(_confirmExternalNavigation).then(_testNetwork).then(_doNavigation).then(_cleanup).then(function (_navigation) {
      logger.debug("".concat(navigationType, ": Finished"));
      resolve(_navigation);
    }, function (_navigation) {
      logger.warn("".concat(navigationType, " failed: ").concat(navigation.failureReason));

      if (!_navigation.navigationItem.initiatedFromSAML && !_navigation.confirmationDeclined) {
        logger.debug("".concat(navigationType, ": Show stop message"));
        getStore().dispatch(workingEnd());
        getStore().dispatch(showStopMessage(getString('global.no.internet.connection')));
      }

      reject(_navigation);
    });
  });
});